import { render, staticRenderFns } from "./InviteAdmin.vue?vue&type=template&id=1dbba74d&scoped=true&"
import script from "./InviteAdmin.vue?vue&type=script&lang=js&"
export * from "./InviteAdmin.vue?vue&type=script&lang=js&"
import style0 from "./InviteAdmin.vue?vue&type=style&index=0&id=1dbba74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbba74d",
  null
  
)

export default component.exports